var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 36,
    viewBox: "0 0 60 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_1583)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4744 35.8962C29.2757 35.8962 29.0902 35.8432 28.9179 35.7505L27.1556 34.7037C26.8906 34.5579 27.0231 34.5049 27.1027 34.4784C27.4604 34.3592 27.5267 34.3326 27.8977 34.1207C27.9374 34.0941 27.9905 34.1074 28.0302 34.1339L29.3818 34.9422C29.4348 34.9687 29.501 34.9687 29.5407 34.9422L34.8278 31.8813C34.8807 31.8548 34.9073 31.8017 34.9073 31.7355V25.627C34.9073 25.5606 34.8807 25.5078 34.8278 25.4812L29.5407 22.4335C29.4877 22.4069 29.4215 22.4069 29.3818 22.4335L24.0947 25.4812C24.0418 25.5076 24.0152 25.5739 24.0152 25.6269V31.7354C24.0152 31.7885 24.0418 31.8547 24.0947 31.8813L25.5391 32.716C26.3209 33.1135 26.8111 32.6497 26.8111 32.186V26.1569C26.8111 26.0775 26.8774 25.9979 26.9701 25.9979H27.6459C27.7255 25.9979 27.8049 26.0642 27.8049 26.1569V32.186C27.8049 33.2327 27.2351 33.8423 26.2413 33.8423C25.9366 33.8423 25.6981 33.8423 25.0222 33.511L23.631 32.716C23.2865 32.5173 23.0745 32.1462 23.0745 31.7487V25.6402C23.0745 25.2427 23.2865 24.8716 23.631 24.6729L28.9179 21.612C29.2493 21.4265 29.6998 21.4265 30.0311 21.612L35.318 24.6729C35.6625 24.8716 35.8746 25.2427 35.8746 25.6402V31.7487C35.8746 32.1462 35.6625 32.5173 35.318 32.716L30.0311 35.7769C29.8587 35.8565 29.6599 35.8962 29.4744 35.8962ZM31.1043 31.6958C28.7855 31.6958 28.3085 30.6357 28.3085 29.7347C28.3085 29.6551 28.3747 29.5756 28.4675 29.5756H29.1565C29.236 29.5756 29.3022 29.6286 29.3022 29.7082C29.4083 30.4104 29.713 30.7549 31.1176 30.7549C32.2306 30.7549 32.7078 30.5032 32.7078 29.9069C32.7078 29.5623 32.5751 29.3107 30.8393 29.1384C29.395 28.9925 28.494 28.6746 28.494 27.5218C28.494 26.4485 29.3951 25.8124 30.9056 25.8124C32.6016 25.8124 33.4365 26.3955 33.5426 27.6674C33.5426 27.7073 33.5293 27.747 33.5028 27.7868C33.4762 27.8133 33.4365 27.8397 33.3967 27.8397H32.7077C32.6414 27.8397 32.5751 27.7868 32.562 27.7205C32.4029 26.9918 31.9921 26.7532 30.9056 26.7532C29.6865 26.7532 29.5407 27.1773 29.5407 27.4952C29.5407 27.8795 29.713 27.9988 31.3561 28.2107C32.9859 28.4228 33.7545 28.7276 33.7545 29.8671C33.7412 31.0332 32.7872 31.6958 31.1043 31.6958Z",
    fill: "#539E43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0701 12.0052C13.0701 11.7668 12.9376 11.5414 12.7256 11.4221L7.10731 8.189C7.01444 8.13591 6.90851 8.10943 6.80257 8.09613H6.74949C6.64355 8.09613 6.5375 8.13591 6.44475 8.189L0.826456 11.4221C0.614354 11.5414 0.481934 11.7666 0.481934 12.0052L0.495233 20.6976C0.495233 20.8169 0.5615 20.9361 0.667437 20.9892C0.773488 21.0554 0.905908 21.0554 0.998774 20.9892L4.33795 19.0811C4.54993 18.9618 4.68247 18.7365 4.68247 18.4981V14.4301C4.68247 14.1916 4.81489 13.9663 5.02699 13.8471L6.44475 13.0255C6.5508 12.9592 6.67004 12.9326 6.78927 12.9326C6.90851 12.9326 7.02774 12.9592 7.12061 13.0255L8.53837 13.8471C8.75047 13.9663 8.88289 14.1915 8.88289 14.4301V18.4981C8.88289 18.7365 9.01542 18.9618 9.22741 19.0811L12.5666 20.9892C12.6726 21.0554 12.8051 21.0554 12.9111 20.9892C13.0172 20.9361 13.0834 20.8169 13.0834 20.6976L13.0701 12.0052ZM40.0751 0.0398121C39.9691 -0.0132707 39.8366 -0.0132707 39.7437 0.0398121C39.6378 0.10608 39.5715 0.212016 39.5715 0.331252V8.94431C39.5715 9.02376 39.5318 9.10321 39.4523 9.1563C39.3728 9.19596 39.2933 9.19596 39.2138 9.1563L37.8092 8.34802C37.7063 8.28938 37.5898 8.25855 37.4713 8.25855C37.3528 8.25855 37.2364 8.28938 37.1334 8.34802L31.5151 11.5944C31.3031 11.7137 31.1706 11.939 31.1706 12.1774V18.657C31.1706 18.8954 31.3031 19.1208 31.5151 19.2401L37.1334 22.4865C37.2364 22.5451 37.3528 22.576 37.4713 22.576C37.5898 22.576 37.7063 22.5451 37.8092 22.4865L43.4275 19.2401C43.6395 19.1208 43.772 18.8956 43.772 18.657V2.50444C43.772 2.25267 43.6395 2.02749 43.4275 1.90814L40.0751 0.0398121ZM39.5583 16.5237C39.5583 16.59 39.5318 16.6429 39.4788 16.6694L37.5575 17.7824C37.5306 17.7955 37.5012 17.8023 37.4713 17.8023C37.4414 17.8023 37.412 17.7955 37.3851 17.7824L35.4638 16.6694C35.4108 16.6429 35.3843 16.5767 35.3843 16.5237V14.2975C35.3843 14.2313 35.4108 14.1783 35.4638 14.1518L37.3851 13.0387C37.412 13.0256 37.4414 13.0188 37.4713 13.0188C37.5012 13.0188 37.5306 13.0256 37.5575 13.0387L39.4788 14.1518C39.5318 14.1782 39.5583 14.2446 39.5583 14.2975V16.5237ZM58.7718 14.2446C58.9839 14.1253 59.1031 13.9 59.1031 13.6615V12.0847C59.1031 11.8462 58.9706 11.6209 58.7718 11.5017L53.1933 8.26856C53.0903 8.20995 52.9739 8.17913 52.8554 8.17913C52.7369 8.17913 52.6205 8.20995 52.5175 8.26856L46.8992 11.5149C46.6871 11.6341 46.5547 11.8594 46.5547 12.098V18.5775C46.5547 18.816 46.6871 19.0413 46.8992 19.1605L52.4777 22.3407C52.6898 22.4599 52.9415 22.4599 53.1403 22.3407L56.5191 20.4593C56.6252 20.4062 56.6915 20.2869 56.6915 20.1677C56.6915 20.0485 56.6252 19.9292 56.5191 19.8762L50.8744 16.6297C50.7684 16.5636 50.7022 16.4575 50.7022 16.3383V14.3109C50.7022 14.1917 50.7684 14.0725 50.8744 14.0194L52.6368 13.0123C52.6884 12.9798 52.7481 12.9626 52.809 12.9626C52.87 12.9626 52.9297 12.9798 52.9813 13.0123L54.7436 14.0194C54.8496 14.0857 54.9159 14.1916 54.9159 14.3109V15.901C54.9159 16.0203 54.9822 16.1395 55.0881 16.1925C55.1941 16.2587 55.3266 16.2587 55.4326 16.1925L58.7718 14.2446Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7693 13.9398C52.7889 13.9269 52.8119 13.92 52.8355 13.92C52.859 13.92 52.882 13.9269 52.9017 13.9398L53.975 14.5626C54.0148 14.589 54.0413 14.6288 54.0413 14.6818V15.9274C54.0413 15.9804 54.0148 16.0201 53.975 16.0466L52.9017 16.6694C52.882 16.6823 52.859 16.6892 52.8355 16.6892C52.8119 16.6892 52.7889 16.6823 52.7693 16.6694L51.6959 16.0466C51.6561 16.0201 51.6296 15.9804 51.6296 15.9274V14.6818C51.6296 14.6288 51.6561 14.589 51.6959 14.5626L52.7693 13.9398Z",
    fill: "#539E43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4647 8.29506C22.3618 8.23645 22.2453 8.20563 22.1269 8.20563C22.0084 8.20563 21.892 8.23645 21.789 8.29506L16.2105 11.5148C15.9984 11.634 15.8792 11.8593 15.8792 12.0978V18.5509C15.8792 18.7894 16.0117 19.0147 16.2105 19.1339L21.789 22.3539C21.892 22.4125 22.0084 22.4433 22.1269 22.4433C22.2453 22.4433 22.3618 22.4125 22.4647 22.3539L28.0434 19.1339C28.2554 19.0147 28.3747 18.7894 28.3747 18.5509V12.0979C28.3747 11.8594 28.2421 11.6341 28.0434 11.5149L22.4647 8.29506Z",
    fill: "url(#paint0_linear_55_1583)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55_1583",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 8,
    width: 14,
    height: 15
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4647 8.29506C22.3618 8.23645 22.2453 8.20563 22.1269 8.20563C22.0084 8.20563 21.892 8.23645 21.789 8.29506L16.2105 11.5148C15.9984 11.634 15.8792 11.8593 15.8792 12.0978V18.5509C15.8792 18.7894 16.0117 19.0147 16.2105 19.1339L21.789 22.3539C21.892 22.4125 22.0084 22.4433 22.1269 22.4433C22.2453 22.4433 22.3618 22.4125 22.4647 22.3539L28.0434 19.1339C28.2554 19.0147 28.3747 18.7894 28.3747 18.5509V12.0979C28.3747 11.8594 28.2421 11.6341 28.0434 11.5149L22.4647 8.29506Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55_1583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0565 11.5148L22.4515 8.29503C22.3964 8.26722 22.3387 8.24502 22.2791 8.22876L15.9983 18.9884C16.0503 19.0519 16.1132 19.1058 16.1839 19.1474L21.7889 22.3674C21.9479 22.4601 22.1334 22.4866 22.3056 22.4335L28.2023 11.6475C28.1625 11.5945 28.1094 11.5545 28.0565 11.5148Z",
    fill: "url(#paint1_linear_55_1583)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_55_1583",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 8,
    width: 14,
    height: 15
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4647 8.29506C22.3618 8.23645 22.2453 8.20563 22.1269 8.20563C22.0084 8.20563 21.892 8.23645 21.789 8.29506L16.2105 11.5148C15.9984 11.634 15.8792 11.8593 15.8792 12.0978V18.5509C15.8792 18.7894 16.0117 19.0147 16.2105 19.1339L21.789 22.3539C21.892 22.4125 22.0084 22.4433 22.1269 22.4433C22.2453 22.4433 22.3618 22.4125 22.4647 22.3539L28.0434 19.1339C28.2554 19.0147 28.3747 18.7894 28.3747 18.5509V12.0979C28.3747 11.8594 28.2421 11.6341 28.0434 11.5149L22.4647 8.29506Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_55_1583)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0699 19.134C28.2289 19.0413 28.3482 18.8823 28.4013 18.7101L22.2527 8.21549C22.0937 8.18901 21.9214 8.20219 21.7758 8.29494L16.2104 11.5017L22.2129 22.4467C22.3002 22.4324 22.385 22.4057 22.4647 22.3673L28.0698 19.1342L28.0699 19.134Z",
    fill: "url(#paint2_linear_55_1583)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0699 19.1341L22.4781 22.354C22.3991 22.3942 22.3141 22.4211 22.2263 22.4334L22.3324 22.6322L28.5337 19.0414V18.9618L28.3746 18.6968C28.3482 18.8823 28.2289 19.0413 28.0699 19.1341Z",
    fill: "url(#paint3_linear_55_1583)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0699 19.1341L22.4781 22.354C22.3991 22.3942 22.3141 22.4211 22.2263 22.4334L22.3324 22.6322L28.5337 19.0414V18.9618L28.3746 18.6968C28.3482 18.8823 28.2289 19.0413 28.0699 19.1341Z",
    fill: "url(#paint4_linear_55_1583)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_1583",
    x1: 867.926,
    y1: 257.18,
    x2: 256.467,
    y2: 1217.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55_1583",
    x1: 544.151,
    y1: 793.384,
    x2: 2075.52,
    y2: -38.6146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4032,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#6CC04A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_55_1583",
    x1: -37.295,
    y1: 720.325,
    x2: 1253.57,
    y2: 720.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_55_1583",
    x1: -632.86,
    y1: 216.552,
    x2: 657.987,
    y2: 216.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_55_1583",
    x1: 846.047,
    y1: -811.958,
    x2: 519.025,
    y2: 901.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_1583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.7084,
    height: 36,
    fill: "white",
    transform: "translate(0.45166)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.7a70d9fc46bc41d2218599fb88aec030.svg";
export { ForwardRef as ReactComponent };